import {
  Activity,
  BarChart3,
  FileText,
  GitFork,
  HelpCircle,
} from 'lucide-react';

import { m } from '@/messages';
import { ConstMap } from '@/utils/ConstMap';

export enum STUDIO_ITEM_STATUS {
  PENDING = 'PENDING',
  COMPLETE = 'COMPLETE',
  FAIL = 'FAIL',
}

export enum STUDIO_ITEM_TYPE {
  CUSTOM_DOCUMENT = 'CUSTOM_DOCUMENT',
  TOP_10_ISSUES_REPORT = 'TOP_10_ISSUES_REPORT',
  FAQ = 'FAQ',
  TOPIC_MAP = 'TOPIC_MAP',
  CHURN_SIGNAL_ANALYSIS = 'CHURN_SIGNAL_ANALYSIS',
}

export const STUDIO_TYPE_NAME_MAP = new ConstMap<STUDIO_ITEM_TYPE, string>([
  [STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT, 'Custom doc'],
  [STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT, 'Top 10 issues report'],
  [STUDIO_ITEM_TYPE.FAQ, 'FAQ'],
  [STUDIO_ITEM_TYPE.TOPIC_MAP, 'Topic map'],
  [STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS, 'Churn signal analysis'],
]);

export const DOC_TEMPLATE_DESCRIPTION_MAP = new ConstMap([
  [
    STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT,
    'Custom report generation based on your specific guidelines',
  ],
  [
    STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT,
    'Top issues by volume with detailed summaries and actual customer quotes.',
  ],
  [
    STUDIO_ITEM_TYPE.FAQ,
    'Top customer questions by volume with recommended answers and suggested improvements.',
  ],
  [
    STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS,
    'Customer churn signals ranked by risk levels. Root causes and retention strategies for each cause.',
  ],
  [STUDIO_ITEM_TYPE.TOPIC_MAP, 'Coming soon'],
]);

export const STUDIO_TEMPLATE_LIST = [
  {
    type: STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT,
    title: STUDIO_TYPE_NAME_MAP.get(STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT),
    description: DOC_TEMPLATE_DESCRIPTION_MAP.get(
      STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT,
    ),
    icon: FileText,
  },
  {
    type: STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT,
    title: STUDIO_TYPE_NAME_MAP.get(STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT),
    description: DOC_TEMPLATE_DESCRIPTION_MAP.get(
      STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT,
    ),
    icon: BarChart3,
  },
  {
    type: STUDIO_ITEM_TYPE.FAQ,
    title: STUDIO_TYPE_NAME_MAP.get(STUDIO_ITEM_TYPE.FAQ),
    description: DOC_TEMPLATE_DESCRIPTION_MAP.get(STUDIO_ITEM_TYPE.FAQ),
    icon: HelpCircle,
  },
  {
    type: STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS,
    title: STUDIO_TYPE_NAME_MAP.get(STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS),
    description: DOC_TEMPLATE_DESCRIPTION_MAP.get(
      STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS,
    ),
    icon: Activity,
  },
  {
    type: STUDIO_ITEM_TYPE.TOPIC_MAP,
    title: STUDIO_TYPE_NAME_MAP.get(STUDIO_ITEM_TYPE.TOPIC_MAP),
    description: DOC_TEMPLATE_DESCRIPTION_MAP.get(STUDIO_ITEM_TYPE.TOPIC_MAP),
    coming_soon: true,
    icon: GitFork,
  },
];

export const getDocTemplate = (type: STUDIO_ITEM_TYPE): string => {
  switch (type) {
    case STUDIO_ITEM_TYPE.CUSTOM_DOCUMENT:
      return m.heySyncly('CUSTOM_DOC_TEMPLATE') as string;
    case STUDIO_ITEM_TYPE.TOP_10_ISSUES_REPORT:
      return m.heySyncly('TOP_10_ISSUES_REPORT_TEMPLATE') as string;
    case STUDIO_ITEM_TYPE.FAQ:
      return m.heySyncly('FAQ_TEMPLATE') as string;
    case STUDIO_ITEM_TYPE.CHURN_SIGNAL_ANALYSIS:
      return m.heySyncly('CHURN_SIGNAL_ANALYSIS_TEMPLATE') as string;
    default:
      throw new Error(`Template not found for type: ${type}`);
  }
};
